import { Button } from './nextButton.styles';
import { updatePage } from '../../redux/pagination';
import { useAppDispatch, useAppSelector } from '../../store';
import { FC } from 'react';
import useBackendPath from '../../hooks/useBackendPath';

interface Props {
  text?: string;
}

const NextButton: FC<Props> = ({ text = 'Next' }) => {
  const { backendPath } = useBackendPath();

  const dispatch = useAppDispatch();
  const { index } = useAppSelector((state) => state.pagination);
  const handleNext = () => {
    dispatch(updatePage(index + 1));
  };
  return (
    <Button onClick={handleNext}>
      {text}
      <img src={`${backendPath}/assets/images/icons/arrow.svg`} alt="" />
    </Button>
  );
};

export default NextButton;
